/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jun 09 2023
 **/

import { CardImageProps } from "@/frameworks/designStuff/components";

import * as S from "./emotion";
import defaultSpaceSrc from "@/assets/images/img_failed_loading_space.png";

const SpaceCard = {
	Layout: S.Layout,
	Image: SpaceCardImage,
	Content: S.Content
};
export default SpaceCard;

function SpaceCardImage({ src, height, errorSrc, ...props }: CardImageProps) {
	return (
		<S.Wrapper type={height} className="space-card__warp">
			<S.Image src={src} type={height} errorSrc={errorSrc ?? defaultSpaceSrc} {...props} />
		</S.Wrapper>
	);
}
